'use es6';

import { connect } from 'react-redux';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { clickCatcherClicked } from 'EmailEditorUI/redux/actions/LayoutActions';
import { getSelectedType } from 'EmailEditorUI/redux/selectors/selected';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    hasSelectedSomething: !!getSelectedType(state)
  };
};
class ClickCatcher extends Component {
  constructor(props) {
    super(props);
    this.onClickCatcherClick = this.onClickCatcherClick.bind(this);
  }
  shouldRenderClickCatcher() {
    if (this.props.shouldShowClickCatcher !== null) {
      return this.props.shouldShowClickCatcher;
    }
    return this.props.hasSelectedSomething;
  }
  onClickCatcherClick() {
    this.props.onClickCatcherClick();
  }
  render() {
    if (this.shouldRenderClickCatcher()) {
      return (
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx("div", {
          "data-test-id": "click-catcher",
          className: "selected-click-catcher",
          onClick: this.onClickCatcherClick
        })
      );
    }
    return null;
  }
}
ClickCatcher.propTypes = {
  hasSelectedSomething: PropTypes.bool.isRequired,
  onClickCatcherClick: PropTypes.func.isRequired,
  shouldShowClickCatcher: PropTypes.bool
};
ClickCatcher.defaultProps = {
  shouldShowClickCatcher: null,
  onClickCatcherClick: false
};
export default connect(mapStateToProps, {
  onClickCatcherClick: clickCatcherClicked
})(ClickCatcher);